<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card" v-if="announcement">
                <div class="card-header pb-0">
                    <div class="justify-content-between d-flex">
                        <div class="d-grid gap-2 d-flex">
                            <!-- <button 
                                type="button"
                                @click="download"
                                :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading ? 'disabled' : '')">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                <i class="fa fa-download" v-if="!loading"></i> Download Form PDF
                            </button>
                            <button 
                                type="button"
                                @click="downloadXlsx"
                                :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading_xlsx ? 'disabled' : '')">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading_xlsx"></span>
                                <i class="fa fa-download" v-if="!loading_xlsx"></i> Download Form XLSX
                            </button>
                            <button 
                                type="button"
                                @click="downloadAnnouncement"
                                :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading_announcement ? 'disabled' : '')">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading_announcement"></span>
                                <i class="fa fa-download" v-if="!loading_announcement"></i> Download announcement
                            </button> -->
                        </div>
                        <argon-badge variant="gradient" color="primary" class="text-xxs align-self-center" v-if="announcement.state">{{ announcement.state }}</argon-badge>
                    </div>
                    <hr/>
                </div>
                <div class="card-body min-vh-80 pt-0">
                    <h5>#{{ announcement.name }}</h5>
                    <div class="row">
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary" width="30%">Title</td>
                                        <td class="font-weight-bold">{{ announcement.title }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Announcement Date</td>
                                        <td class="font-weight-bold">{{ announcement.date_announcement }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Vendor</td>
                                        <td class="font-weight-bold">{{ announcement.vendor }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary" width="30%">Announcement Period</td>
                                        <td class="font-weight-bold">{{ announcement.date_start }} - {{ announcement.date_end }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Responsible</td>
                                        <td class="font-weight-bold">{{ announcement.responsible }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Priority</td>
                                        <td class="font-weight-bold">{{ announcement.priority }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-12">
                            <div v-html="announcement.description"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonBadge from '../components/ArgonBadge.vue'
const endpoint = require("../router/endpoint");

export default {
  name: "announcement-detail",
  data() {
    return {
      announcement: null,
      loading: false,
      loading_announcement: false,
      loading_xlsx: false,
    };
  },
  components: {
    ArgonBadge
  },
  methods: {
    getAnnouncementDetail() {
      this.axios
        .post(
          endpoint.ANNOUNCEMENT_DETAIL,
          {
            id: this.$route.params.id,
            partner_id: localStorage.getItem("partner_id")
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.response_code === "0000") {
            this.announcement = response.data.data;
          } else {
            this.$notify({
              type: "warn",
              title: "Warning",
              text: response.data.message
            });
          }
          this.loading = false;
        })
        .catch((e) => {
          this.$notify({
            type: "error",
            title: "Failed",
            text: e.response.data.message
          });
          this.loading = false;
        });
    },
    download () {
        this.loading = true
        this.axios
            .post(
            endpoint.DOWNLOAD,
            {
                res_id: this.$route.params.id,
                template_report: 'stock_request.action_report_delivery_notes'
            },
            {
                headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            }
            )
            .then((response) => {
            if (response.data.response_code === "0000") {
                const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
                const downloadLink = document.createElement("a");
                const fileName = this.announcement.name + ".pdf";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                if (response.data.response_code !== "4000"){
                this.$notify({
                    type: 'warn',
                    title: 'Warning',
                    text: response.data.message,
                });
                }
            }
            this.loading = false
            })
            .catch((e) => {
            this.loading = false;
            this.$notify({
                type: 'error',
                title: 'Something went wrong!',
                text: e.response.data.message,
                });
            });
        },
    downloadXlsx () {
        this.loading_xlsx = true
        this.axios
            .post(
            endpoint.DOWNLOAD,
            {
                res_id: this.$route.params.id,
                template_report: 'stock_request.delivery_notes_xlsx'
            },
            {
                headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            }
            )
            .then((response) => {
            if (response.data.response_code === "0000") {
                const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.data.data.file}`;
                const downloadLink = document.createElement("a");
                const fileName = this.announcement.name + ".xlsx";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                if (response.data.response_code !== "4000"){
                this.$notify({
                    type: 'warn',
                    title: 'Warning',
                    text: response.data.message,
                });
                }
            }
            this.loading_xlsx = false
            })
            .catch((e) => {
            this.loading_xlsx = false;
            this.$notify({
                type: 'error',
                title: 'Something went wrong!',
                text: e.response.data.message,
                });
            });
        },
    downloadAnnouncement () {
        this.loading_announcement = true
        this.axios
            .post(
            endpoint.DOWNLOAD,
            {
                res_id: this.$route.params.id,
                template_report: 'stock_request.action_report_announcement_vendor'
            },
            {
                headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            }
            )
            .then((response) => {
            if (response.data.response_code === "0000") {
                const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
                const downloadLink = document.createElement("a");
                const fileName = this.announcement.name + ".pdf";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                if (response.data.response_code !== "4000"){
                this.$notify({
                    type: 'warn',
                    title: 'Warning',
                    text: response.data.message,
                });
                }
            }
            this.loading_announcement = false
            })
            .catch((e) => {
            this.loading_announcement = false;
            this.$notify({
                type: 'error',
                title: 'Something went wrong!',
                text: e.response.data.message,
                });
            });
        }
  },
  mounted() {
    this.getAnnouncementDetail();
  }
};
</script>

<style>

</style>